
import "./index.scss";
import {Link} from "react-router-dom";
import ShowFullInfoIcon from "../../assets/icons/ShowFullInfoIcon";
import EyeIcon from "../../assets/icons/EyeIcon";
import React from "react";

const ReportAloneItem = ({id, status, date, modalStatus, setModalActive, allowChangeStatus, statusesList = [], link, email, phone, anotherContact, message, cost}) => {
    const getStatusName = (statusKey) => {
        const status = statusesList.find(s => s.key === statusKey);
        return status ? status.name : statusKey;
    };

    const getColorForStatus = (statusKey) => {
        const STATUS_COLOR = {
            'not_active': '#008ECA',
            'refuse': '#A7000E',
            'not_target': '#B4A8DE',
            'contact': '#FFC75A',
            'success': '#7367F0',
            'payment': '#008B67'
        };
        return STATUS_COLOR[statusKey] || '#000000';
    }

    const formatValue = (value) => {
        if (value === null || value === undefined) return null;
        if (typeof value === 'number') {
            return value;
        }
        if (Array.isArray(value)) {
            if (value.length === 0) return null;
            const validItems = value.filter(item => 
                item !== null && 
                item !== undefined && 
                item !== 'null' && 
                item !== 'undefined' &&
                (typeof item !== 'string' || item.trim() !== '')
            );
            if (validItems.length === 0) return null;
            return validItems[0];
        }
        if (typeof value === 'string') {
            if (value.trim().startsWith('[') && value.trim().endsWith(']')) {
                try {
                    const parsed = JSON.parse(value);
                    if (Array.isArray(parsed) && parsed.length > 0) {
                        const validItems = parsed.filter(item => 
                            item !== null && 
                            item !== undefined && 
                            item !== 'null' && 
                            item !== 'undefined' &&
                            (typeof item !== 'string' || item.trim() !== '')
                        );
                        if (validItems.length > 0) return validItems[0];
                    }
                } catch (e) {
                }
            }
            const trimmed = value.trim();
            if (trimmed === '' || trimmed === 'null' || trimmed === 'undefined') return null;
            return trimmed;
        }
        if (value === 'null' || value === 'undefined') return null;
        return value;
    }

    const getInfoContent = () => {
        const infoItems = [];
        
        const formattedLink = formatValue(link);
        const formattedMessage = formatValue(message);
        const formattedCost = formatValue(cost);
        const formattedEmail = formatValue(email);
        const formattedPhone = formatValue(phone);
        const formattedAnotherContact = formatValue(anotherContact);
        
        if (formattedLink && formattedLink !== 'null') {
            infoItems.push(
                <a 
                    key="link"
                    href={formattedLink} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="report-alone-item__info report-alone-item__info-link"
                >
                    {formattedLink}
                </a>
            );
        }
        if (formattedMessage && formattedMessage !== 'null') {
            infoItems.push(
                <span key="message" className="report-alone-item__info report-alone-item__info-message">
                    {formattedMessage}
                </span>
            );
        }
        if (formattedCost && formattedCost !== 'null') {
            infoItems.push(
                <span key="cost" className="report-alone-item__info">
                    {formattedCost} ₽
                </span>
            );
        }
        if (formattedEmail && formattedEmail !== 'null') {
            infoItems.push(
                <span key="email" className="report-alone-item__info">
                    {formattedEmail}
                </span>
            );
        }
        if (formattedPhone && formattedPhone !== 'null') {
            infoItems.push(
                <span key="phone" className="report-alone-item__info">
                    {formattedPhone}
                </span>
            );
        }
        if (formattedAnotherContact && formattedAnotherContact !== 'null') {
            infoItems.push(
                <span key="anotherContact" className="report-alone-item__info">
                    {formattedAnotherContact}
                </span>
            );
        }
        
        if (infoItems.length === 0) return null;
        
        return (
            <div className="report-alone-item__info-container">
                {infoItems.map((item) => item)}
            </div>
        );
    }

    return (
        <div className="report-main-container">
        <div className="report-alone-item">
            <div className="report-alone-item__top-row">
                <div className="report-alone-item__name">
                  №{id}
                </div>
                {getInfoContent()}
                <div className="report-alone-item__status"
                    style={{color: status && getColorForStatus(status)}}>
                    {getStatusName(status)}
                </div>
            </div>
            <div className="report-alone-item__bottom-row">
                <div className="report-alone-item__date">
                    {date ? (date.includes('T') ? `${date.split('T')[0]} ${date.split('T')[1]?.split('.')[0] || ''}` : date) : ''}
                </div>
                <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
                    <Link to={`/app/main/edit-report/${id}`}>
                        <div className="report-alone-item__icon-edit">
                            <EyeIcon/>
                        </div>
                    </Link>
                    <div className="report-alone-item__icon-share"
                         onClick={() => 
                            {allowChangeStatus &&
                                setModalActive({
                             id,
                             isActive: true
                         })}}
                    >
                        <ShowFullInfoIcon allowChangeStatus={allowChangeStatus}/>
                    </div>
                </div>
            </div>
        </div>
        </div>
    );
};

export default ReportAloneItem;
